var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebstorm = function SvgWebstorm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "webstorm_svg__a",
    x1: 7.621,
    x2: 61.248,
    y1: 64.719,
    y2: 39.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F0EB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "webstorm_svg__b",
    x1: 60.019,
    x2: 1.313,
    y1: 59.778,
    y2: 1.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00C4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#007DFE"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EB18",
    d: "m5.818 48.051.002 11.876a4.07 4.07 0 0 0 4.073 4.072h11.506c1.19 0 2.319-.52 3.093-1.422l32.71-38.162c.632-.738.98-1.678.98-2.65V9.889a4.073 4.073 0 0 0-4.073-4.073H42.601c-1.189 0-2.319.52-3.092 1.422L6.799 45.4a4.07 4.07 0 0 0-.98 2.651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#webstorm_svg__a)",
    d: "M5.818 49.483v10.446a4.073 4.073 0 0 0 4.073 4.073h13.093q.289 0 .576-.04l36.943-5.278A4.07 4.07 0 0 0 64 54.652V38.979a4.073 4.073 0 0 0-4.074-4.073l-18.538.005c-.438 0-.872.07-1.287.209L8.603 45.62a4.07 4.07 0 0 0-2.785 3.863"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#webstorm_svg__b)",
    d: "M0 4.073V38.04c0 1.63.971 3.102 2.468 3.743l37.49 16.069c.507.216 1.054.329 1.605.329h18.364A4.073 4.073 0 0 0 64 54.109V36.143c0-.804-.239-1.591-.685-2.26L41.91 1.812A4.07 4.07 0 0 0 38.524.003L4.073 0A4.073 4.073 0 0 0 0 4.073"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52 12H12v40h40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.238 27.961-2.423-10.953h-3.032l3.623 15.004h3.322l2.561-10.9 2.53 10.9h3.333l3.644-15.004h-2.97L29.48 27.96l-2.701-10.953H23.82zM38.222 31.68q1.265.59 2.894.59c1.63 0 2.052-.2 2.895-.6q1.264-.6 1.96-1.651a4.2 4.2 0 0 0 .708-2.39q0-1.084-.482-1.994a4.36 4.36 0 0 0-1.35-1.543 4.9 4.9 0 0 0-1.962-.858l-2.55-.557q-.697-.171-1.105-.579-.397-.408-.397-1.029 0-.546.29-.953.289-.419.804-.643.525-.236 1.21-.236.686 0 1.211.246.535.235.825.675.29.429.29.976h2.926q-.012-1.286-.686-2.272-.665-.998-1.865-1.555c-.8-.371-1.726-.557-2.733-.557q-1.512 0-2.701.579-1.189.568-1.854 1.596-.664 1.019-.664 2.305 0 1.061.439 1.907a4.1 4.1 0 0 0 1.233 1.426q.792.57 1.864.804l2.648.59q.76.182 1.19.654.439.47.439 1.19 0 .578-.322 1.028-.31.45-.89.707c-.378.165-.8.247-1.328.247q-.794 0-1.404-.279a2.3 2.3 0 0 1-.954-.771 1.96 1.96 0 0 1-.343-1.147h-2.936q.021 1.383.728 2.444.718 1.061 1.972 1.65M16.993 44h16v3h-16z"
  })));
};
export default SvgWebstorm;